import React, { useMemo } from 'react';
import { MoveDown } from 'lucide-react';
import type { DiscountBoxProps } from './discount-box.types';
import { cn } from '../../../lib/utils';
import Icon from '../../atoms/icon';
import Text from '../../atoms/text';
import { DotsLoader } from '../dots-loader';
import styles from './discount-box.module.css';

export const DiscountBox: React.FC<DiscountBoxProps> = ({
    className,
    primaryIconProps,
    primaryText,
    primaryTextProps,
    secondaryText,
    secondaryTextProps,
    loading,
}) => {
    const disocuntBoxStyles = useMemo(() => {
        return {
            container: cn(styles.container, className),
            primaryIcon: cn(styles.primaryIcon, primaryIconProps?.className),
            primaryText: cn(styles.primaryText, primaryTextProps?.className),
            secondaryText: cn(styles.secondaryText, secondaryTextProps?.className),
        };
    }, [className, primaryIconProps?.className, primaryTextProps?.className, secondaryTextProps?.className]);

    return (
        <div className={disocuntBoxStyles.container} data-testid="discount-box">
            <Icon
                testID="discount-box-icon"
                showIf={!!primaryIconProps}
                icon={MoveDown}
                className={disocuntBoxStyles.primaryIcon}
                {...primaryIconProps}
            />
            <div className={styles.textWrapper}>
                <Text
                    data-testid="discount-box-primary-text"
                    showIf={!!primaryText}
                    {...primaryTextProps}
                    className={disocuntBoxStyles.primaryText}
                >
                    {primaryText}
                </Text>
                {loading ? (
                    <DotsLoader size="small" color="white" />
                ) : (
                    <Text
                        data-testid="discount-box-secondary-text"
                        showIf={!!secondaryText}
                        {...secondaryTextProps}
                        className={disocuntBoxStyles.secondaryText}
                    >
                        {secondaryText}
                    </Text>
                )}
            </div>
        </div>
    );
};
